import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button } from '@mui/material';
import { useState } from 'react';

import RolePermissionsMatrix from '@/components/RolePermissions/RolePermissionsUserMatrix';
import type { PermissionSectionProps } from '@/features/UserEditDialog/UserEditDialog.types';

export const RolePermissionDropdown = ({
  userRoles,
  allRoles
}: PermissionSectionProps) => {
  const [permissionsExpanded, setPermissionsExpanded] = useState(false);

  return (
    <Box>
      <Button
        variant="text"
        onClick={() => setPermissionsExpanded(!permissionsExpanded)}
        endIcon={
          <FontAwesomeIcon
            icon={permissionsExpanded ? faChevronUp : faChevronDown}
            style={{ fontSize: '1rem' }}
          />
        }
        size="small"
      >
        Display Role Permissions
      </Button>

      {permissionsExpanded && (
        <RolePermissionsMatrix
          userRoles={userRoles || []}
          allRoles={allRoles || []}
        />
      )}
    </Box>
  );
};

export default RolePermissionDropdown;
